import { SavedReportsCard } from "@/Features/SavedReports";
import { saveStorageReport } from "../../../../api";

const StorageSavedReports = ({ reportInfo }) => (
  <SavedReportsCard reportInfo={reportInfo} saveReport={saveStorageReport} />
);

export default StorageSavedReports;
